module.exports = __webpack_public_path__ + "31a5dfafb026cf933697a12fd743ca81.svg";